export const initialMessage = 
    {
      id: 0,
      titolo: "LISTA VUOTA",
      descrizione:
        "Utilizza l'Editor degli imprevisti accessibile dal menu (insieme alle Istruzioni in formato PDF) per aggiungere quelli che vuoi vengano usati per le estrazioni",
        isImprev: 1,
        ultEstrazione: 0,
    }
  ;